<template>
  <div>
    <div class="row">
      <div class="col col-md-12 col-sm-12 text-center">
        <div class="d-flex justify-content-center"
          v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }">
          <Combo :itens="$global.sites_filtro_completo()" v-model="filtroSite"
            style="max-width: 150px; margin-right: 10px; display: none" v-if="
              retornaSite() !== 'Share' &&
              retornaSite() !== 'Stream1x2' &&
              retornaSite() !== '7live'
            " />

          <div style="margin-right: 10px" v-if="
            retornaSite() !== 'Share' &&
            retornaSite() !== 'Stream1x2' &&
            retornaSite() !== '7live' &&
            propView == 'completo'
          ">
            <button type="button" class="btn btn-sm btn-light" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <small>Tipo<br /></small>
              <small>{{ filtroPlanoTipo }}</small>
            </button>
            <div class="dropdown-menu">
              <span class="dropdown-item" style="cursor: pointer" @click="
                filtroPlanoTipo = 'Todos';
              carregarItens();
              ">Todos</span>
              <span class="dropdown-item" style="cursor: pointer" @click="
                filtroPlanoTipo = 'assinante';
              carregarItens();
              ">Assinante</span>
              <span class="dropdown-item" style="cursor: pointer" @click="
                filtroPlanoTipo = 'ajuste';
              carregarItens();
              ">Ajuste</span>
              <span class="dropdown-item" style="cursor: pointer" @click="
                filtroPlanoTipo = 'teste';
              carregarItens();
              ">Teste</span>
            </div>
          </div>

          <DataFiltro :value="filtroData" @change="carregarItens()" v-bind:style="{
            display: propView == 'completo' ? 'block' : 'none',
          }" @reload="carregarItens()" :propEnabledExportar="true" @export="exportItens()" />

          <input class="form-control inputPesquisa" style="max-width: 80%; margin-right: 10px; display: none"
            type="text" placeholder="Email..." v-model="filtroUsuario" @keyup="keyupFiltroUsuario" />
        </div>

        <hr v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }" />

        <div class="row" v-if="retornaSite() == 'Weddbets'">
          <div class="col col-md-1"></div>
          <div class="col col-md-5" v-for="(headerSite, headerSiteKey) in headerSites" :key="headerSiteKey"
            :item="headerSite">
            <ListCardsProgress :itens="headerSite" />
          </div>
        </div>

        <div class="rowLista">
          <div class="list-group-item" v-for="item in itens" :key="item.key" :item="item">
            <div class="row">
              <div class="col col-md-12">
                <div class="d-flex w-100 justify-content-between">
                  <div class="d-flex justify-content-start">
                    <button @click="excluir(item)" v-if="item.status == 'Agendado'" type="button"
                      class="btn btn-outline-secondary btn-sm" style="zoom: 0.6; max-height: 28px; margin-right: 10px">
                      X
                    </button>
                    <h6 class="mb-1" v-bind:style="{
                      display: propView == 'usuario' ? 'block' : 'none',
                    }">
                      {{ item.plano.nome }}
                      <small class="text-secondary" v-bind:style="{
                        display:
                          retornaSite() == '7live' && propView == 'usuario'
                            ? ''
                            : 'none',
                      }">
                        (€ {{ item.plano.valor }})</small>
                    </h6>
                    <h6 class="mb-1" v-bind:style="{
                      display: propView == 'completo' ? 'block' : 'none',
                    }">
                      {{ item.usuario.email }}
                    </h6>
                    <h6 class="mb-1 text-secondary" style="margin-left: 6px"
                      v-if="propView == 'completo' && item.indicacao !== null">
                      <small>/ {{ item.indicacao.email }}</small>
                    </h6>
                  </div>
                  <h6>
                    <small v-if="item.status == 'Corrente'"><b>Finaliza em {{ item.diasRestantes }} dia(s)</b></small>
                    <small v-if="item.status == 'Agendado'"><b>Inicia em {{ item.diasRestantes }} dia(s)</b></small>
                    <small v-if="item.status == 'Finalizado'"><b>Finalizou a {{ item.diasRestantes }} dia(s)</b></small>
                  </h6>
                </div>
                <div>
                  <p class="text-secondary textoResumo d-flex w-100 justify-content-between">
                    <small><span>Lançamento: {{ formatDateTime(item.dataLancamento) }}</span>
                      <span v-bind:style="{
                        display: propView == 'completo' ? '' : 'none',
                      }">
                        | Plano: {{ item.plano.nome }}</span><span v-if="retornaSite() !== '7live' && retornaSite() !== 'Stream1x2'">
                        | {{ item.plano.site }}</span><span v-if="retornaSite() == '7live'">
                        (€ {{ item.plano.valor }})</span></small>
                    <small>Período: {{ formatDate(item.dataInicio) }} -
                      {{ formatDate(item.dataFim) }} ({{
                        item.duracao
                      }}
                      dias)</small>
                  </p>
                </div>
                <div class="d-flex justify-content-start" v-if="retornaSite() == 'Weddbets'">
                  <span class="text-secondary mr-1" v-if="
                    item.usuarioCriacaoObjeto &&
                    item.usuarioCriacaoObjeto.length > 0
                  ">
                    <small>{{ item.usuarioCriacaoObjeto[0].nome }} </small>
                  </span>
                  <span class="text-secondary" v-if="item.comprovante && item.comprovante !== ''">
                    <small>({{ item.comprovante }})</small>
                  </span>
                  <span style="margin-left: 7px;margin-top:0px"><svg xmlns="http://www.w3.org/2000/svg" title="Pay" width="16"
                      height="16" fill="currentColor" class="bi bi-credit-card-2-back" viewBox="0 0 16 16" v-if="item.pp && item.pp !== null">
                      <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5z">
                      </path>
                      <path
                        d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1m-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1">
                      </path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }" style="margin-top: 15px">
          Total de {{ itens.length }} itens
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

import util from "../includes/util.js";

import Combo from "../components/Combo.vue";
import DataFiltro from "../components/DataFiltro.vue";
import ListCardsProgress from "../components/ListCardsProgress.vue";

export default {
  name: "ListPlanosCliente",
  components: { Combo, DataFiltro, ListCardsProgress },
  props: {
    itensLimit: { type: Number, default: 50 },
    propUsuario: { type: String, default: "" },
    propView: { type: String, default: "usuario" },
  },
  methods: {
    limpar() {
      this.$set(this.item, "plano", "");
      this.itens = [];
      this.planos = [];
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItensUsuario(idUsuario) {
      const responsePlano = await api.get("/plano/usuario/" + idUsuario);
      api.valid(responsePlano.data, this.$router);

      if (!responsePlano.data.erro) {
        this.itens = responsePlano.data.itens;
      }
    },
    async carregarItens() {
      const responsePlano = await api.get(
        "/plano/usuarios?data=" +
        this.filtroData.dia +
        "-" +
        this.filtroData.mes +
        "-" +
        this.filtroData.ano +
        (this.filtroPlanoTipo !== "Todos"
          ? "&planoTipo=" + this.filtroPlanoTipo
          : "")
      );
      api.valid(responsePlano.data, this.$router);

      if (!responsePlano.data.erro) {
        this.itens = responsePlano.data.itens;

        if (this.retornaSite() == "Weddbets" && this.propView == "completo") {
          var headerSites = {};

          //* Registra o total de planos por sites
          this.itens.forEach((element) => {
            if (!headerSites[element.plano.site]) {
              headerSites[element.plano.site] = {
                nome: element.plano.site,
                quantidade: 0,
                planos: [],
              };
            }

            if (!headerSites[element.plano.site].planos[element.plano.nome]) {
              headerSites[element.plano.site].planos[element.plano.nome] = {
                nome: element.plano.nome,
                quantidade: 0,
              };
            }

            headerSites[element.plano.site].quantidade =
              headerSites[element.plano.site].quantidade + 1;
            headerSites[element.plano.site].planos[
              element.plano.nome
            ].quantidade =
              headerSites[element.plano.site].planos[element.plano.nome]
                .quantidade + 1;
          });

          var headerSitesTotal = 0;

          //* Percorre os sites para calcular os totais e ordenar os planos
          for (const headerSiteKey in headerSites) {
            headerSitesTotal =
              headerSitesTotal + headerSites[headerSiteKey].quantidade;
            headerSites[headerSiteKey].planos = Object.values(
              headerSites[headerSiteKey].planos
            ).sort((a, b) => b.quantidade - a.quantidade);
          }

          this.headerSites = {};

          //* Insere os sites no elemento de cards
          for (const headerSiteKey in headerSites) {
            this.headerSites[headerSiteKey] = [];

            //* Insere o card do site
            this.headerSites[headerSiteKey].push({
              cor: "bg-success",
              titulo: headerSites[headerSiteKey].nome,
              subtitulo:
                "Planos " +
                headerSites[headerSiteKey].quantidade +
                " de " +
                headerSitesTotal,
              valor: headerSites[headerSiteKey].quantidade,
              total: headerSitesTotal,
            });

            //* Insere o card de cada plano
            for (const headerPlanoKey in headerSites[headerSiteKey].planos) {
              this.headerSites[headerSiteKey].push({
                cor: "bg-warning",
                titulo: headerSites[headerSiteKey].planos[headerPlanoKey].nome,
                subtitulo:
                  "Planos " +
                  headerSites[headerSiteKey].planos[headerPlanoKey].quantidade +
                  " de " +
                  headerSites[headerSiteKey].quantidade,
                valor:
                  headerSites[headerSiteKey].planos[headerPlanoKey].quantidade,
                total: headerSites[headerSiteKey].quantidade,
              });
            }
          }
        }
      }
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },

    async excluir(item) {
      if (confirm("Deseja excluir o item ?")) {
        const responsePlano = await api.post("/plano/usuario/excluir", {
          usuario: item.usuario._id,
          key: item.key,
        });
        api.valid(responsePlano.data, this.$router);

        if (!responsePlano.data.erro) {
          if (this.propView == "usuario") {
            this.carregarItensUsuario(item.usuario._id);
            this.$emit("item-excluido");
          } else {
            this.carregarItens();
          }
        }
      }
    },
    keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);

      var obj = this;

      this.timerFiltroUsuario = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
    exportItens() {
      var conteudo =
        "site\tdata\temail\tplano\tdias\tinicio\tfim\tpay\tindicacao\tcomprovante\tlancamento\n";

      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        var item = this.itens[indiceItem];
        conteudo +=
          item.plano.site +
          "\t" +
          this.formatDateTime(item.dataLancamento) +
          "\t" +
          item.usuario.email +
          "\t" +
          item.plano.nome +
          "\t" +
          item.plano.duracao +
          "\t" +
          this.formatDate(item.dataInicio) +
          "\t" +
          this.formatDate(item.dataFim) +
          "\t" +
          (item.pp && item.pp !== null ? "sim" : "não") +
          "\t" +
          (item.indicacao ? item.indicacao.email : "") +
          "\t" +
          (item.comprovante ? item.comprovante : "") +
          "\t" +
          (item.usuarioCriacaoObjeto && item.usuarioCriacaoObjeto.length > 0
            ? item.usuarioCriacaoObjeto[0].nome
            : "") +
          "\n";
      }

      this.$copyText(conteudo).then(
        function (e) {
          alert("Copiado com sucesso!");
          console.log(e);
        },
        function (e) {
          alert("Impossivel copiar!");
          console.log(e);
        }
      );
    },
  },
  mounted() {
    var dataAtual = new Date();
    this.filtroData.dia = dataAtual.getDate();
    this.filtroData.mes = dataAtual.getMonth() + 1;
    this.filtroData.ano = dataAtual.getFullYear();
  },
  data: function () {
    return {
      //filtroTexto: "",
      filtroUsuario: "",
      filtroPlanoTipo: "Todos",
      filtroData: { dia: 0, mes: 0, ano: 0 },
      filtroSite: "Todos",
      //ordem:"vencimento_ASC",
      item: { plano: "" },
      itens: [],
      planos: [],
      headerSites: {},
      itensTotal: 0,
      editItem: null,
      timerFiltroUsuario: null,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}

.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
